<template>
  <div class="row">
    <div class="col-12">
      <filter-component />
      <table-component />
    </div>
  </div>
</template>

<script>
  import FilterComponent from '@pbx/components/sip-accounts/list/filter';
  import TableComponent from '@pbx/components/sip-accounts/list/table';

  export default {
    components: {
      FilterComponent,
      TableComponent
    }
  };
</script>
